var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8503 59H1V53.5036H18.8503H19.8503V52.5036V30.2018V29.6216L19.3466 29.3336L8.04002 22.87C6.43812 21.9354 5.43387 20.6336 4.97277 18.9318C4.51276 17.234 4.73455 15.6196 5.66906 14.0288L5.66907 14.0288L5.67174 14.0242L11.3251 4.28188C12.2638 2.69132 13.5744 1.69069 15.2934 1.23091C17.0089 0.772045 18.6356 0.994135 20.2321 1.92368L20.2321 1.9237L20.2374 1.92674L54.8224 21.7813L33.5753 37.5377L26.8843 33.7364L25.3904 32.8877V34.6059V52.5036C25.3904 54.2956 24.7599 55.8067 23.4685 57.0906C22.177 58.3747 20.656 59.0022 18.8515 59H18.8503ZM50.918 40.0662L44.6184 36.4666L56.0522 28.0221L62.2743 31.6186L50.918 40.0662Z",
    stroke: "#353435",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCam);
export default __webpack_public_path__ + "static/media/icon_cam.215d6e279bb1a5157a1a3fe66717b96b.svg";
export { ForwardRef as ReactComponent };